import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Theme, Typography } from '@mui/material';

import { SatelliteManager } from 'models';

import RefreshButton from 'components/RefreshButton';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'grid',
            gap: theme.spacing(1),
        },
        satelliteRoot: {
            display: 'grid',
            gap: theme.spacing(1),
        },
        topSection: {
            display: 'grid',
            gridTemplateColumns: '1fr auto',
            gap: theme.spacing(1),
        },
        disabled: {
            color: 'red',
            fontSize: 12,
        },
        subsection: {
            paddingLeft: theme.spacing(2),
        },
    }),
);

interface OverviewProps {
    satellite: SatelliteManager.Satellite;
    onRefreshClick?: () => void;
    isRefreshing?: boolean;
    hideRefresh?: boolean;
    tleDetails?: [string, Date];
}

const SatelliteOverview: React.FunctionComponent<OverviewProps> = ({
    satellite,
    onRefreshClick,
    isRefreshing,
    hideRefresh,
    tleDetails,
}) => {
    const classes = useStyles();
    const colour = satellite.enabled ? 'Green' : 'Grey';

    if (tleDetails) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const tleDate: Date = tleDetails[1];
    }

    return (
        <div className={classes.root}>
            <div className={classes.satelliteRoot}>
                <div className={classes.topSection}>
                    <div>
                        {/* Display name, enabled, norad_name */}

                        <Typography variant="h6">
                            {satellite.name} : {satellite.norad_name}{' '}
                            {!satellite.enabled && (
                                <span className={classes.disabled}>
                                    (disabled)
                                </span>
                            )}
                        </Typography>
                        {tleDetails && (
                            <div className={classes.subsection}>
                                <Typography variant="subtitle2" color={colour}>
                                    {satellite.enabled
                                        ? 'Enabled'
                                        : 'Not Enabled'}
                                </Typography>
                                <Typography variant="subtitle1">
                                    Catelogue Number:{' '}
                                    {satellite.catalogue_number}
                                </Typography>

                                <Typography variant="subtitle1">
                                    Description: {satellite.description}
                                </Typography>

                                {/* Display latest tle created date (orbit model) */}

                                <Typography variant="subtitle1">
                                    Latest tle{' '}
                                    <span style={{ fontWeight: 'bold' }}>
                                        {tleDetails[0]?.toString()}{' '}
                                    </span>
                                    last uploaded at{' '}
                                    <span style={{ fontWeight: 'bold' }}>
                                        {tleDetails[1]?.toLocaleTimeString()}{' '}
                                        {tleDetails[1]?.toLocaleDateString()}
                                    </span>
                                </Typography>

                                {/* Display next scheduled downlink time NOTE omitted as the schedule summary component already displays ample information about the next schedules coming up, including next downlink time? */}
                                <Typography variant="subtitle2"></Typography>
                            </div>
                        )}
                    </div>

                    <div>
                        {!hideRefresh && (
                            <RefreshButton
                                onClick={onRefreshClick}
                                isRefreshing={isRefreshing}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

SatelliteOverview.displayName = 'SatelliteOverview';
export default SatelliteOverview;
